<template>
  <div class="row view-task" v-if="isRequestUpdated && request">
    <div class="col">
      <div class="row view-task-header">
        <div class="col mx-2 justify-content-between">
          <form class="form-inline py-2 justify-content-between">
            <div class="d-flex align-items-center justify-content-between w-50">
              <button type="button" class="btn btn-back btn-lg" @click="returnBack">
                <i class="fa fa-angle-left px-1"></i>
              </button>
              <h2 class="ml-4">{{request.name}}</h2>
            </div>
            <div class="view-task-top-buttons d-flex align-items-center" v-if="isAdAgent">
              <button type="button" class="ml-4 btn btn-outline-secondary" @click="editRequest">
                <i class="ico ico-pencil"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div class="row view-task-details my-4 mx-2">
        <div class="col-md-12 col-lg-9 task-details-description">
          <div class="row px-2 py-4">
            <div class="col-2 task-description-plates">
              <div class="task-description-plate">
                <span class="plate-number">{{request.local_id}}</span>
              </div>
              <div class="task-description-plate plate-date mt-2">
                <span class="plate-date mt-2">{{request.dedlineDate}}</span>
                <span class="plate-date">{{request.dedlineTime}}</span>
              </div>
            </div>
            <div class="col-10 task-description-info">
              <div>
                <div class="d-flex justify-content-between">
                  <div class="view-task-comments-history-toggle w-75 pr-4">
                    <div class="d-flex align-items-center">
                      <div class="status-filters d-flex align-items-baseline">
                        <div
                          class="status-fiter"
                          @click="toggeleInfoMap"
                          :class="{'filter-active' : isActiveInfoMap}"
                        >
                          <p class="h3">Инфокарта</p>
                        </div>
                        <div
                          class="status-fiter"
                          @click="toggeleTechMap"
                          :class="{'filter-active' : isActiveTechMap}"
                        >
                          <p class="h3">Техкарта</p>
                        </div>
                      </div>
                    </div>
                    <div v-if="isActiveInfoMap">
                      <p class="task-description-info-text ml-2 mt-4">{{request.description}}</p>
                    </div>
                    <div
                      class="tech-card form-group align-items-top mt-2 mr-4"
                      v-if="isActiveTechMap"
                    >
                      <div class="tech-card__body" v-if="requestTechMap.length > 0">
                        <div
                          class="tech-card__body-item px-3 py-3"
                          v-for="(item, index) in requestTechMap"
                          :key="index"
                          :title="item.printMachineName"
                        >
                          <div class="d-flex flex-wrap align-items-center justify-content-between">
                            <div class="d-flex align-items-center w-100">
                              <i
                                class="tech-card__body-toggle fa fa-angle-down cursor-pointer mr-3"
                                v-if="item.expanded"
                                @click="() => item.expanded = false"
                              ></i>
                              <i
                                class="tech-card__body-toggle fa fa-angle-right cursor-pointer mr-3"
                                v-else
                                @click="() => item.expanded = true"
                              ></i>
                              <div class="d-flex flex-column w-100">
                                <div class="d-flex align-items-center justify-content-between">
                                  <span class="tech-card__body-title" :title="item.name">
                                    {{item.name}}
                                    <span>, {{(+item.cost).toFixed(2)}}</span>
                                  </span>
                                  <span
                                    class="tech-card__body-title tech-card__body-title--no-wrap ml-2"
                                  >{{item.printing}} шт.</span>
                                </div>
                                <span
                                  class="tech-card__body-name"
                                  :title="item.name"
                                >{{item.printMachineName}}</span>
                              </div>
                            </div>
                          </div>
                          <template v-if="item.expanded">
                            <div
                              class="tech-card__details pl-4 ml-1"
                              v-for="(section, index) in item.sections"
                              :key="index"
                            >
                              <template v-if="section.blocks.length > 0">
                                <p class="tech-card__details-section mt-2 mb-0">{{section.name}}</p>
                                <dl
                                  class="row my-0"
                                  v-for="(block, index) in section.blocks"
                                  :key="index"
                                >
                                  <dt
                                    class="tech-card__details-block col-sm-3 my-0 py-0"
                                  >{{block.name}}</dt>
                                  <dd class="col-sm-9 my-0 py-0">{{block.value}}</dd>
                                </dl>
                              </template>
                            </div>
                          </template>
                        </div>
                      </div>
                      <div>
                        <p class="task-description-info-text ml-2 mt-4">{{request.techMapDesc}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="w-25">
                    <dl>
                      <dt class="my-0 py-0"></dt>
                      <dd class="my-0 py-0">
                        <b>{{$t('home.start_date')}}:</b>
                      </dd>
                      <dt class="my-0 py-0"></dt>
                      <dd class="my-0 py-0">{{request.creationDate}}</dd>
                    </dl>
                    <dl v-if="request.client">
                      <dt class="my-0 py-0"></dt>
                      <dd class="my-0 py-0">
                        <b>{{$t('home.client')}}:</b>
                      </dd>
                      <template v-if="request.client.legal_entity">
                        <dt class="my-0 py-0"></dt>
                        <dd class="my-0 py-0">{{request.client.legal_entity.name}}</dd>
                        <dt class="my-0 py-0" v-if="request.client.name"></dt>
                        <dd class="my-0 py-0" v-if="request.client.name">{{request.client.name}}</dd>
                        <dt class="my-0 py-0"></dt>
                        <dd
                          class="my-0 py-0"
                        >{{request.client.telephone || request.client.legal_entity.telephone}}</dd>
                        <dt class="my-0 py-0"></dt>
                        <dd
                          class="my-0 py-0"
                        >{{request.client.email || request.client.legal_entity.email}}</dd>
                        <br />
                        <dt class="my-0 py-0"></dt>
                        <dd
                          class="my-0 py-0"
                        >{{request.client.description || request.client.legal_entity.description}}</dd>
                      </template>
                      <template v-else>
                        <dt class="my-0 py-0"></dt>
                        <dd class="my-0 py-0">{{request.client.name}}</dd>
                        <dt class="my-0 py-0"></dt>
                        <dd class="my-0 py-0">{{request.client.telephone}}</dd>
                        <dt class="my-0 py-0"></dt>
                        <dd class="my-0 py-0">{{request.client.email}}</dd>
                        <br />
                        <dt class="my-0 py-0"></dt>
                        <dd class="my-0 py-0">{{request.client.description}}</dd>
                      </template>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-3 text-center task-details-actions">
          <div class="row px-2 py-4">
            <div class="col">
              <div class="row">
                <div class="col task-details-price">
                  <span class="price-view">{{request.price}}</span>
                </div>
              </div>
              <div class="row">
                <div class="col task-details-main-actions">
                  <div class="d-flex flex-column">
                    <button
                      class="btn btn-sm btn-primary mt-2"
                      @click="acceptRequest"
                      v-if="!isAdAgent"
                    >Принять</button>
                    <button
                      class="btn btn-sm btn-outline-primary mt-2"
                      @click="cancelRequest"
                      v-if="isAdAgent"
                    >Удалить</button>
                    <button
                      class="btn btn-sm btn-outline-primary mt-2"
                      @click="cancelRequest"
                      v-else
                    >Отклонить</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row view-task-comments-history-toggle mx-2 mt-4" v-if="layouts.length">
        <div class="col">
          <div class="d-flex align-items-center">
            <div class="status-filters d-flex align-items-baseline">
              <div class="status-fiter filter-active">
                <p class="h3">Макеты</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row view-task-layouts mx-2 mt-2">
        <div class="col-8 p-2 view-task-layouts-items">
          <div>
            <dl
              class="mt-4 pl-4 d-flex justify-content-between"
              v-for="layout in layouts"
              :key="layout.id"
            >
              <div class="mr-2 py-2 w-100">
                <dt class="my-0 py-0"></dt>
                <template v-if="layout.file">
                  <dd class="my-0 py-0 d-flex">
                    <b>Файл:</b>
                  </dd>
                  <dt class="my-0 py-0"></dt>
                  <dd class="my-0 py-0">
                    <a
                      :href="`/api/file-manager/files/${layout.file.id}/download`"
                    >{{layout.file.name}}</a>
                  </dd>
                </template>
                <template v-else-if="layout.link">
                  <dd class="my-0 py-0 d-flex">
                    <b>Ссылка:</b>
                  </dd>
                  <dt class="my-0 py-0"></dt>
                  <dd class="my-0 py-0 link">{{layout.link}}</dd>
                </template>
                <dt class="my-0 py-0"></dt>
                <dd class="my-0 py-0">
                  <b>Описание:</b>
                </dd>
                <dt class="my-0 py-0"></dt>
                <dd class="my-0 py-0">{{layout.description}}</dd>
              </div>
              <div class="text-right view-task-layouts-items__actions">
                <div
                  class="btn-group btn-group-sm btn-group-vertical"
                  role="group"
                  aria-label="Basic example"
                >
                  <a
                    v-if="layout.file"
                    class="btn btn-secondary"
                    :href="`/api/file-manager/files/${layout.file.id}/download`"
                  >
                    <i class="fa fa-download cursor-pointer"></i>
                  </a>
                  <button
                    v-else-if="layout.link"
                    type="button"
                    class="btn btn-secondary"
                    @click="copyLayoutLink(layout)"
                  >
                    <i class="fa fa-copy cursor-pointer"></i>
                  </button>
                </div>
              </div>
            </dl>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import roles from '../../../helpers/userRoles'
import api from '../../../api'
import moment from 'moment'
import _ from 'lodash'
import { mapActions } from 'vuex'
import copy from 'copy-to-clipboard'

export default {
  name: 'RequestView',
  props: {
    requestId: {
      default: null
    }
  },
  data: () => {
    return {
      roles: roles,
      isActiveInfoMap: true,
      isActiveTechMap: false,
      requestTechMap: [],
      layouts: [],
      invoices: [],
      previousRoute: null,
      isRequestUpdated: false,
      isSendRequest: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.previousRoute = from
      vm.$eventBus.$emit('pageHeaderChange', 'Детали задачи')
    })
  },
  computed: {
    request () {
      const requestId = +this.requestId
      const request = this.$store.state.requests.find(function (request) {
        return request.id === requestId
      }, this)

      if (!request || !this.isRequestUpdated) {
        return null
      }

      const result = _.cloneDeep(request)
      result.dedlineDate = moment(result.end_time).format('DD MMMM YYYY')
      result.dedlineTime = moment(result.end_time).format('HH:mm')
      result.creationDate = moment(result.start_time).format(
        'DD MMMM YYYY HH:mm'
      )
      result.techMapDesc = request.tech_map_desc

      return result
    },
    isAdAgent () {
      return this.$store.getters.role === roles.adAgent
    }
  },
  watch: {
    request: function (newVal) {
      const requestId = +this.requestId
      const request = this.$store.state.requests.find(function (request) {
        return request.id === requestId
      }, this)

      this.requestTechMap = request.tech_map
        ? Object.keys(request.tech_map).map(x => {
          return { ...request.tech_map[x], id: x, expanded: false }
        })
        : []

      this.layouts = request.layouts.map(x => {
        return { id: _.uniqueId(), link: x.link, description: x.description, file: x.file }
      })

      if (!newVal && !this.isSendRequest) {
        this.$router.replace('/')
      }
    }
  },
  async created () {
    await this.updateRequest(this.requestId)
    this.isRequestUpdated = true
  },
  methods: {
    returnBack () {
      if (
        this.previousRoute.path.indexOf('/tasks') === 0 ||
        this.previousRoute.path.indexOf('/ad-agent/tasks') === 0
      ) {
        this.$router.push(this.previousRoute.path)
      } else {
        this.$router.push('/')
      }
    },
    editRequest () {
      this.$router.push(`/ad-agent/update-request/${this.requestId}`)
    },
    toggeleInfoMap () {
      this.isActiveInfoMap = true
      this.isActiveTechMap = false
    },
    toggeleTechMap () {
      this.isActiveInfoMap = false
      this.isActiveTechMap = true
    },
    copyLayoutLink (item) {
      copy(item.link)
    },
    async acceptRequest () {
      this.isSendRequest = true
      try {
        const response = await api.get.convertRequestToTask(this.requestId)
        this.$router.push(`/view-task/${response.data.data.task.id}`)
      } catch (ex) {
        this.isSendRequest = false
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
      }
    },
    async cancelRequest () {
      this.isSendRequest = true
      try {
        await api.get.deleteRequest(this.requestId)
        this.returnBack()
      } catch (ex) {
        this.$notify({
          message: 'Произошла ошибка',
          type: 'danger'
        })
        this.isSendRequest = false
      }
    },
    ...mapActions({
      updateRequest: 'UPDATE_REQUEST'
    })
  }
}
</script>

<style lang="scss">
.view-task {
  .tech-card__body-item + .tech-card__body-item {
    border-top: 1px solid #ced4da;
  }

  .tech-card {
    &__body {
      border: 1px solid #ced4da;
      border-radius: 4px;
    }

    &__body-item + &__body-item {
      border-top: 1px solid #ced4da;
    }

    &__body-toggle {
      color: #28bd8b;
      font-size: 18px;
    }

    &__body-title {
      text-transform: uppercase;
      font-size: 14px;
      font-weight: 700;

      &--no-wrap {
        white-space: nowrap;
      }
    }

    &__body-name {
      text-transform: uppercase;
      font-size: 12px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: #7b7c7d;
    }

    &__details {
      &-section {
        font-weight: 700;
      }

      &-block {
        color: #7b7c7d;
        font-size: 13px;
      }
    }
  }

  .view-task-top-buttons {
    position: relative;

    &__print-list {
      list-style: none;
      position: absolute;
      top: calc(100% - 3px);
      left: 0;
      border: 1px solid #7b7c7d;
      z-index: 1;

      &-item {
        text-transform: uppercase;
        color: #7b7c7d !important;
        font-weight: bold;
        background-color: white;
        border-color: #7b7c7d;
      }
    }
  }

  .view-task-layouts-items {
    dl {
      background-color: #f0f3f6;
      border: 1px solid darken(#f0f3f6, 10);
      border-radius: 4px;

      b {
        color: #7b7c7d;
      }

      .link {
        color: #297fb8;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    &__actions {
      font-size: 14px;
      color: #7b7c7d;
    }
  }
}
</style>
